import {
  reportInfo,
  usePublishAgentPageContext,
} from '../../../agentChat/pageContext';

type ReportContextSliceProps = {
  title: string;
  description: string;
};

/**
 * WBAgentReportContextSlice publishes the report's title and description. Mount
 * once per loaded report.
 */
export const WBAgentReportContextSlice = ({
  title,
  description,
}: ReportContextSliceProps) => {
  usePublishAgentPageContext(reportInfo, {
    title: title || undefined,
    description: description || undefined,
  });
  return null;
};
